import * as types from '@/store/mutationTypes';
import customFormService from '@/http/services/customFormService';

export const actions = {
    sendCustomForms: async (context, payload) => {
        await customFormService.setCustomForms(payload);
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/customForm/actions.js